import type { ForgotPassword } from '~/types';
import { BaseModel } from '~/models/base-model';

export class ForgotPasswordModel extends BaseModel<ForgotPassword> {
    email = '';
}
